import produce from 'immer';
import {
  GET_EMPLOYER,
  GET_EMPLOYERS,
  GET_EMPLOYERS_SUCCESS,
  GET_EMPLOYER_JOBS,
  GET_EMPLOYER_JOBS_SUCCESS,
  GET_EMPLOYER_SUCCESS,
  GET_EMPLOYER_ERROR,
  GET_EMPLOYER_JOBS_ERROR, 
} from './constants';

export const initialState = {
  loading: false,
  error: null,
  employers: [],
  employer: null,
  employerJobs: [],
  employesJobsLoading: false,
  page: 1,
  currentPage: 1,
  pageCount: 1,
};

const employersReducer = (state = initialState, action: any) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_EMPLOYERS:
        draft.loading = true;
        draft.error = null;
        draft.employers= [];
        break;
      case GET_EMPLOYERS_SUCCESS:
        draft.loading= false;
        draft.currentPage = action?.response?.data?.meta?.current_page || 1;
        draft.pageCount = action?.response?.data?.meta?.last_page || 1;
        draft.employers = action.response.data.data || [];
        break; 
      case GET_EMPLOYER:
        draft.loading = true;
        draft.error = null;
        draft.employer = null;
        break;
      case GET_EMPLOYER_SUCCESS:
        draft.loading= false;
        draft.employer = action.response.data;
        break;  
      case GET_EMPLOYER_ERROR:
        draft.loading= false;
        draft.employer = null;
        break;  

      case GET_EMPLOYER_JOBS:
        draft.employesJobsLoading = true;
        draft.error = null;
        break;
      case GET_EMPLOYER_JOBS_SUCCESS:
        draft.employesJobsLoading = false;
        draft.currentPage = action?.response?.data?.meta?.current_page || 1;
        draft.pageCount = action?.response?.data?.meta?.last_page || 1;
        draft.employerJobs = action.response.data.data || [];
        break;  
      case GET_EMPLOYER_JOBS_ERROR:
        draft.employesJobsLoading = false;
        //draft.error = null;
        break;  
    }
  });

export default employersReducer;
